import { Component, Input, TemplateRef } from "@angular/core";

import { NzEmptyComponent } from "ng-zorro-antd/empty";
import { UiEmptyNotFoundImageType } from "@webapp/ui/empty/empty.models";

@Component({
  selector: "ui-empty",
  exportAs: "uiEmpty",
  templateUrl: "empty.component.html",
})
export class UiEmptyComponent extends NzEmptyComponent {
  @Input("uiNotFoundImage") public nzNotFoundImage: UiEmptyNotFoundImageType = "default";
  @Input("uiNotFoundContent") public nzNotFoundContent?: string | TemplateRef<void> | null;
  @Input("uiNotFoundFooter") public nzNotFoundFooter?: string | TemplateRef<void>;
}
